@if (video) {
  <div class="video_splash d-flex justify-content-between">
    <div class="d-flex">
      <img *inView [src]="video.thumb" alt="thumbnail" aria-label="thumbnail" />
      <div>
        <span>{{ video.title }}</span>
        <br />
        @if (replies && replies.length) {
          <span>{{ "com.latest_comment" | translate }}: {{ replies[0].created.toDate() | date: "MMM Do" : true }}</span>
        }
      </div>
    </div>
    <button (click)="showVideo(video)" class="btn btn-primary" aria-label="view video">{{ "com.view_video" | translate }}</button>
  </div>
}
<div
  class="card"
  [class.scheduled]="comment.scheduled_date"
  [class]="isCommunityPost ? 'community-post' : 'comment-container'"
  [class.employee-only]="comment.employee_only"
  [class.queued]="queued"
  [class.force-dark]="forceDark"
  [class.flagged]="user && user?.is_sphere_admin && comment.flags && comment.flags.length && !comment.cleared"
  [id]="comment.id"
>
  @if (user?.is_sphere_admin && comment.flags && comment.flags.length && !comment.cleared) {
    <div class="flag-warning bold">
      {{ comment.flags.length + " " + (comment.flags.length > 1 ? ("com.flags" | translate) : ("com.flag" | translate)) + "!" }}
    </div>
  }
  @if (isCommunityPost) {
    <!--
      Posts with a subject read as threads: channel, then subject, then a compact byline
      under a divider (see `.message-header.subject-first` in _community.scss). The DOM
      order below is unchanged — CSS `order` moves the rows — so the subject is placed
      between the two lists and the author list keeps its hover card, badges and link.
      Subject-less posts keep the author-first chat layout.
    -->
    <div class="message-header" [class.subject-first]="hasSubject">
      <!-- @if (comment.pinned && betaStringId) {
        <div class="pinned-indicator m-b-10 m-l-40">
          <fa-icon icon="thumbtack" class="c-primary m-r-5"></fa-icon>
          <span class="t-12 bold text-muted">PINNED POST</span>
        </div>
      } -->
      <ul class="list-inline d-flex align-items-center author-row" [class.m-l-40]="!hasSubject">
        <li class="list-inline-item mr-0">
          <!-- DENG-846: hover card. Community posts only — the same template renders
               workspace/file comments, where there is no community profile to show. -->
          <a href="javascript:void(0)" (click)="viewProfile(comment.author.id)" class="profile-photo-container" [mypUserHoverCard]="comment.author.id" [hoverCardDisabled]="!isCommunityPost">
            @if (comment.author.id == user?.id ? user?.photoURL : comment.author.photo) {
              <img [src]="comment.author.id == user?.id ? userService.profilePicture : comment.author.photo" class="profile-photo" [alt]="comment.author.name + ' profile photo'" />
            } @else {
              <!--
                Initials-in-a-colored-circle fallback (2026-09-01) — replaces the
                generic person-silhouette default avatar. Color is derived from a hash
                of the author id, pre-computed in `_hydrateAuthorAvatar()` and stored
                as `author._avatarColor` / `author._initials` so the template can read
                plain properties (no method calls in bindings — perf rule).
              -->
              <div class="profile-photo profile-photo-initials" [style.background-color]="comment.author._avatarColor" aria-hidden="true">
                {{ comment.author._initials }}
              </div>
            }
            <span class="sr-only">{{ comment.author.name }} profile</span>
          </a>
        </li>
        <li class="list-inline-item m-r-5">
          <a href="javascript:void(0)" class="text-decoration-none" (click)="viewProfile(comment.author.id)">
            <fui-heading [text]="comment.author.name" [level]="2" fontSize="f6" extraClasses="t-18 bold author-name"></fui-heading>
          </a>
          <span class="sr-only">{{ comment.author.name }} profile</span>
        </li>
        @if (comment.sphere_only && user?.is_sphere_admin) {
          <li class="list-inline-item m-r-5" placement="top" [ngbTooltip]="('com.only_shows_in' | translate) + ' ' + env.studioOnePlusBrandName">
            <img src="./assets/icons/plus-icon-blue.png" style="width: 15px; height: 15px" alt="only shows in studio one pro+" />
          </li>
        }
        @if (userService.badgeUsersMap?.community_moderators && userService.badgeUsersMap?.community_moderators[comment.author.id]) {
          <li class="list-inline-item m-r-5">
            <div [ngbTooltip]="'com.community_moderator' | translate" [triggers]="isMobileScreen ? 'manual' : 'hover focus'" tabindex="0" [attr.role]="isMobileScreen ? 'button' : null">
              <fa-icon icon="star" class="community-wizard-badge t-18" aria-hidden="true"></fa-icon>
              <span class="sr-only">community moderator</span>
            </div>
          </li>
        }
        @if (userService.badgeUsersMap && userService.badgeUsersMap.employees && userService.badgeUsersMap.employees[comment.author.id]) {
          <li class="list-inline-item m-r-5">
            <div [ngbTooltip]="'com.fender_employee' | translate" [triggers]="isMobileScreen ? 'manual' : 'hover focus'" tabindex="0" [attr.role]="isMobileScreen ? 'button' : null">
              <img src="./assets/icons/fender-f.png" class="community-employee-badge" alt="fender employee" aria-hidden="true" />
              <span class="sr-only">fender employee</span>
            </div>
          </li>
        }
        @if (userService.badgeUsersMap?.experts && userService.badgeUsersMap?.experts[comment.author.id]) {
          <li class="list-inline-item m-r-5">
            <div [ngbTooltip]="'com.studio_one_expert' | translate" [triggers]="isMobileScreen ? 'manual' : 'hover focus'" tabindex="0" [attr.role]="isMobileScreen ? 'button' : null">
              <fa-icon icon="graduation-cap" class="community-employee-badge" aria-hidden="true"></fa-icon>
              <span class="sr-only">studio one expert</span>
            </div>
          </li>
        }
        <li class="list-inline-item m-r-5" [class.fui-eyebrow]="!hasSubject">
          <!--
            Timestamp is a real `<a href>` (not a click-only span) so search-engine
            crawlers can follow it from the prerendered feed into individual post-detail
            URLs — wave 1 of docs/community-seo-plan.md. Users still get Angular routing
            via `[routerLink]`; the `detailClick()` handler only primes the back-cache.
          -->
          <a class="time-created" [routerLink]="postDetailLink" [queryParams]="postDetailQueryParams" (click)="detailClick()" aria-label="posted on">
            {{ (queued ? comment.created : comment.created.toDate()) | date: "MMM Do [at] h:mma" : true }}
          </a>
        </li>
      </ul>
      @if (hasSubject) {
        <div class="main-post-subject" [innerHTML]="comment.subject"></div>
      }
      <ul class="list-inline channels m-r-5">
        @if (comment.employee_only) {
          <li class="list-inline-item" ngbTooltip="Only PreSonus/Fender employees can see this post.">
            <span class="channel blue">{{ "com.employee_only" | translate }}</span>
          </li>
        }
        <!-- Untagged posts no longer render a "General" pill — dropped alongside the removal of the general built-in filter (DENG-728 follow-up). -->

        @if (comment.topics && comment.topics.length && displayedSection != "topics") {
          <li class="list-inline-item m-r-5">
            <span class="topic" (click)="topicSelected.next(comment.topics[0])">
              <span class="t-10">{{ "com.from" | translate }}</span>
              &nbsp;
              <strong>{{ communityService.topicMap[comment.topics[0]].title }}</strong>
            </span>
          </li>
        }
        <!-- Community and channel pills: the same `.community-post-tag` design as the feed's list rows. -->
        @if (communityTag) {
          <li class="list-inline-item">
            <span class="community-post-tag community-post-tag--community">
              <span class="community-post-tag__dot" [style.background]="communityTag.accent" aria-hidden="true"></span>
              {{ communityTag.title }}
            </span>
          </li>
        }
        @if (comment.channels && !betaStringId) {
          @for (channel of comment.channels; track channel) {
            <li class="list-inline-item">
              @if (communityService.skillsMap[channel] || communityService.extraChannelsMap[channel]) {
                <a
                  class="community-post-tag"
                  [class.disabled]="communityService.extraChannelsMap[channel] && !communityService.extraChannelsMap[channel].active"
                  (click)="selectChannel(channel)"
                  tabindex="0"
                  href="javascript:void(0)"
                >
                  #{{ (communityService.skillsMap[channel] || communityService.extraChannelsMap[channel])?.title | localize: channel }}
                  <span class="sr-only">— go to channel</span>
                </a>
              }
            </li>
          }
        }
        @if (comment.channels && betaStringId) {
          @for (channel of comment.channels; track channel) {
            @if (betaService.communityTagMap[channel] && !betaManagerEditingChannels) {
              <li class="list-inline-item">
                <a href="javascript:void(0)" class="channel" (click)="selectChannel(channel)" tabindex="0"># {{ betaService.communityTagMap[channel].title }}</a>
              </li>
            }
          }
          @if (betaStringId && !betaManagerEditingChannels && isBetaManager) {
            <li class="t-12 list-inline-item">
              <button class="small-btn" (click)="betaManagerEditingChannels = true"><fa-icon icon="pencil"></fa-icon></button>
            </li>
          }
          @if (betaManagerEditingChannels) {
            <li class="list-inline-item position-relative">
              @for (channel of comment.channels; track channel) {
                @if (betaService.communityTagMap[channel]) {
                  <span class="create-post-selected-channel">
                    # {{ betaService.communityTagMap[channel].title }}
                    <button class="m-l-5 fa-button" (click)="removeChannel(channel)">
                      <fa-icon icon="times-circle"></fa-icon>
                    </button>
                  </span>
                }
              }
              @if (!comment.channels || comment.channels.length < 3) {
                <button
                  class="add-channel-button c-lblue bold pointer"
                  aria-controls="channel-list"
                  [attr.aria-expanded]="shouldShowChannelSelector"
                  (click)="shouldShowChannelSelector = !shouldShowChannelSelector"
                >
                  {{ "com.add_channel" | translate }}
                  <fa-icon icon="plus-circle" class="c-lblue t-14"></fa-icon>
                </button>
              }
              @if (shouldShowChannelSelector) {
                <div class="channel-selector" id="channel-list">
                  <div class="channel-list overflow-auto h-100">
                    @for (tag of betaService.communityTags; track tag) {
                      <button class="channel-button bold pointer t-14 p-1" (click)="addChannel(tag)">
                        <fa-icon icon="hashtag" class="c-lblue"></fa-icon>
                        {{ tag.title }}
                      </button>
                    }
                  </div>
                </div>
              }
              <button class="small-btn" (click)="betaManagerEditingChannels = false">Done</button>
            </li>
          }
        }
      </ul>
    </div>
  }

  <div class="msg">
    @if (!isCommunityPost) {
      <div class="d-flex">
        <ul class="list-inline bold">
          <li class="list-inline-item">
            @if (comment.author?.photo) {
              <img [src]="comment.author.photo" class="profile-photo" [alt]="comment.author.name + ' profile photo'" />
            } @else {
              <div class="profile-photo profile-photo-initials" [style.background-color]="comment.author._avatarColor" aria-hidden="true">
                {{ comment.author._initials }}
              </div>
            }
          </li>
          <li class="list-inline-item">
            <a href="javascript:void(0)" (click)="viewProfile(comment.author.id)" class="bold t-14 author-name" [class.force-dark]="forceDark">{{ comment.author.name }}&nbsp;</a>
          </li>
          @if (userService.badgeUsersMap?.community_wizards && userService.badgeUsersMap?.community_wizards[comment.author.id]) {
            <li class="list-inline-item">
              <div [ngbTooltip]="'com.community_moderator' | translate" [triggers]="isMobileScreen ? 'manual' : 'hover focus'" tabindex="0" [attr.role]="isMobileScreen ? 'button' : null">
                <fa-icon icon="star" class="community-wizard-badge t-18" aria-hidden="true"></fa-icon>
                <span class="sr-only">community moderator</span>
              </div>
            </li>
          }
          @if (userService.badgeUsersMap && userService.badgeUsersMap.employees && userService.badgeUsersMap.employees[comment.author.id]) {
            <li class="list-inline-item">
              <div [ngbTooltip]="'com.fender_employee' | translate" [triggers]="isMobileScreen ? 'manual' : 'hover focus'" tabindex="0" [attr.role]="isMobileScreen ? 'button' : null">
                <img src="./assets/icons/fender-f.png" class="community-employee-badge" alt="fender employee" aria-hidden="true" />
                <span class="sr-only">fender employee</span>
              </div>
            </li>
          }
          @if (userService.badgeUsersMap && userService.badgeUsersMap.experts && userService.badgeUsersMap.experts[comment.author.id]) {
            <li class="list-inline-item">
              <div [ngbTooltip]="'com.studio_one_expert' | translate" [triggers]="isMobileScreen ? 'manual' : 'hover focus'" tabindex="0" [attr.role]="isMobileScreen ? 'button' : null">
                <fa-icon icon="graduation-cap" class="community-employee-badge" aria-hidden="true"></fa-icon>
                <span class="sr-only">studio one expert</span>
              </div>
            </li>
          }
          <li class="list-inline-item">
            <div class="timestamp">{{ comment.created.toDate() | date: "MMM Do [at] h:mma" : true }}</div>
          </li>
        </ul>
      </div>
    }
    <!-- Community posts render their subject in the header above. -->
    @if (comment.subject && !isCommunityPost) {
      <div class="main-post-subject" [innerHTML]="comment.subject"></div>
    }
    @if (comment.htmlMessage || !comment.htmlSignature) {
      <p class="text main-post-text mb-0" [class.emoji-only-message]="comment.isEmojiOnly" [innerHTML]="comment.htmlMessage ? (comment.htmlMessage | safe: 'html') : comment.message"></p>
    }
    <!-- The author's signature, set apart from the post (smaller, under a rule). -->
    @if (comment.htmlSignature) {
      <div class="post-signature" [innerHTML]="comment.htmlSignature | safe: 'html'"></div>
    }
    @if (queued && comment.files?.length) {
      <div class="m-t-20 text-muted">
        {{ "com.attached_files" | translate: { count: comment.files.length } }}
        <br />
        <br />
        {{ "com.post_is_queued" | translate }}
      </div>
    }
    @if (queued && !comment.files?.length) {
      <div class="m-t-20 text-muted">
        <fa-icon icon="spinner" animation="spin"></fa-icon>
        {{ "com.sending_post" | translate }}
      </div>
    }

    <!-- START | comment has files -->
    @if (comment.files && comment.files.length && !queued) {
      <div class="post-attachments" [class.multiple]="comment.files.length > 1">
        @for (file of comment.files; track file) {
          <div class="attachment" [class.is-image]="workspaceService.imageFiles[file.extension]">
            @if (workspaceService.imageFiles[file.extension]) {
              <div *inView>
                <img [src]="communityService.buildFileUrl(file.user_id, file)" (click)="showImage(communityService.buildFileUrl(file.user_id, file))" class="image-border" alt="" />
                <div class="p-x-5">
                  <span class="t-12 font-weight-bold">{{ file.filename }}</span>
                </div>
              </div>
            }
            @if (workspaceService.audioFiles[file.extension]) {
              <div class="m-t-20">
                @if (communityService.displayAudioWaveforms) {
                  @if (comment.shouldLoadWaveform) {
                    <myp-waveform-comments (audioPlayed)="audioPlayed($event)" [showComments]="false" #waveformComments [isPostAttachment]="true" [file]="file"></myp-waveform-comments>
                  }
                  @if (!comment.shouldLoadWaveform) {
                    <div style="height: 150px; background-color: rgba(0, 0, 0, 0.6)" class="d-flex align-items-center justify-content-center">
                      <div class="text-center">
                        <a href="javascript:void(0)" class="btn btn-primary" (click)="comment.shouldLoadWaveform = true">{{ "com.load_waveform" | translate }}</a>
                        <br />
                        <span>{{ file.filesize | bytesToSize }}</span>
                      </div>
                    </div>
                  }
                }
                @if (!communityService.displayAudioWaveforms) {
                  <div class="post-audio-play" [class.pulse-blue]="communityService.playingAudioFile && communityService.playingAudioFile.id == file.id" (click)="playAudio(file, comment.id, $event)">
                    <!-- <canvas [id]="comment.id + '_visualizer'" style="position: absolute; width: 100%; height: 100%;"></canvas> -->
                    <fa-icon [icon]="communityService.playingAudioFile && communityService.playingAudioFile.id == file.id ? 'stop-circle' : 'play-circle'" class="t-40"></fa-icon>
                    <div class="m-l-10 flex-column align-items-left">
                      <fui-heading [text]="file.filename" [level]="3" fontSize="f7" extraClasses="t-20 bold d-block"></fui-heading>
                      <p class="text-muted t-16 mb-0">{{ file.filesize | bytesToSize }}</p>
                    </div>
                  </div>
                }
              </div>
            }
            @if (workspaceService.videoFiles[file.extension]) {
              <div *inView>
                <video width="100%" [src]="file.url" controls></video>
              </div>
            }
            @if (!workspaceService.imageFiles[file.extension] && !workspaceService.audioFiles[file.extension] && !workspaceService.videoFiles[file.extension]) {
              <div role="button" class="generic-file-attachment pointer" (click)="downloadFile(file)">
                {{ file.filename }}
                <fa-icon icon="download" aria-hidden="true"></fa-icon>
                <span class="sr-only">download</span>
              </div>
            }
          </div>
        }
      </div>
    }
    <!-- END | comment has files -->

    <!-- START | comment has learn content -->
    @if (comment.learn_content && comment.learn_content.length && !queued) {
      <div class="post-attachments m-y-20 grid-container pad-10">
        @for (item of comment.learn_content; track item) {
          @if (item.content.type == "video") {
            <myp-video-grid-item [video]="item.content"></myp-video-grid-item>
          }
          @if (item.content.type == "course" || item.content.type == "lesson") {
            <myp-learn-list-item [item]="item.content"></myp-learn-list-item>
          }
        }
      </div>
    }
    <!-- END | comment has learn content -->

    <!-- START | comment has embeds -->
    @if (comment.embeds && comment.embeds.length && !queued) {
      <div class="post-attachments">
        @for (embed of comment.embeds; track embed) {
          <div class="message-embed message-embed--{{ embed.type }} message-embed--{{ embed.subtype }}">
            <iframe width="560" height="315" [src]="embed.src" frameborder="0" allowfullscreen></iframe>
          </div>
        }
      </div>
    }
    <!-- END | comment has embed -->

    <!-- START | comment has articles -->
    @if (comment.articles && comment.articles.length && !queued) {
      <ul class="post-attachments" role="group" aria-label="articles">
        @for (item of comment.articles; track item) {
          <li style="list-style-type: none">
            <button type="button" class="comment-article-attachment bg-transparent" (click)="showArticle(item)">
              <fa-icon icon="newspaper" class="icon" aria-hidden="true"></fa-icon>
              <div class="d-flex flex-column text-left">
                <fui-heading [text]="item.article.name" [level]="4" fontSize="f7" extraClasses="bold"></fui-heading>
                <span class="t-12 text-muted" aria-label="article created at">{{ item.article.created_at_pretty }}</span>
                <div class="block text-right">
                  <span class="link bold">
                    {{ "com.read_article" | translate }}
                    <fa-icon icon="chevron-right" aria-hidden="true"></fa-icon>
                  </span>
                </div>
              </div>
            </button>
          </li>
        }
      </ul>
    }
    <!-- END | comment has articles -->

    <!-- START | comment has public file links -->
    @if (comment.public_file_links && comment.public_file_links.length && !queued) {
      <ul class="post-attachments" role="group" aria-label="links">
        @for (item of comment.public_file_links; track item) {
          <li style="list-style-type: none">
            <button type="button" class="comment-article-attachment bg-transparent" (click)="goToPublicFile(item)">
              <fa-icon [icon]="workspaceService.audioFiles[item.publicFile.extension] ? 'play-circle' : 'file'" class="icon" aria-hidden="true"></fa-icon>
              <div class="d-flex flex-column text-left">
                <fui-heading [text]="item.publicFile.filename" [level]="4" fontSize="f7" extraClasses="bold"></fui-heading>
                <span class="t-12 text-muted" aria-label="article created at">{{ item.publicFile.description }}</span>
                <div class="block text-right">
                  <span class="link bold">
                    {{ "com.view_and_comment" | translate }}
                    <fa-icon icon="chevron-right" aria-hidden="true"></fa-icon>
                  </span>
                </div>
              </div>
            </button>
          </li>
        }
      </ul>
    }
    <!-- END | comment has public file links -->

    @if (isBetaManager && comment.pinned) {
      <div>
        <button class="brand-btn-reverse sm" (click)="deletePinnedPost()">{{ "com.delete_pinned_post" | translate }}</button>
        &nbsp;
        <button class="brand-btn-reverse sm" (click)="editPost(comment, true)">{{ "com.edit_pinned_post" | translate }}</button>
        &nbsp;
        <button class="brand-btn-reverse sm" (click)="unpinBetaPost()">{{ "com.unpin_post" | translate }}</button>
      </div>
    }

    <!-- Separate from the block above because admins can open/close comments without being beta managers. -->
    @if (canToggleAnnouncementComments) {
      <div class="m-t-10">
        <button class="brand-btn-reverse sm" (click)="toggleAnnouncementComments()">
          {{ commentsAllowedOnPinned ? "Disable Comments" : "Enable Comments" }}
        </button>
      </div>
    }

    @if (!queued && !pinnedAndLocked) {
      <div class="timestamp justify-content-between">
        <ul class="list-inline mb-0">
          @if (!communityService.profile || !communityService.profile.status || communityService.profile.status == "active") {
            @if (comment.edited) {
              <li class="list-inline-item">
                <span class="edited-message">{{ "com.edited" | translate }}</span>
              </li>
            }
            <myp-reaction-control [comment]="comment" (reactionChange)="onReactionChange($event)" (viewProfile)="viewProfile($event)"></myp-reaction-control>
            @if (!reviewing && isCommunityPost && !betaStringId) {
              <li class="list-inline-item">
                <!--
                  `.action-pill` (in _comments.scss) carries the shape, so `btn-transparent`
                  and `msg-options-link` are deliberately absent: those two are what tinted
                  the glyph Fender red and scaled it 1.1x on hover. Saved is a pill STATE
                  (`--on`) rather than an icon colour.
                  Users know this as "Save" (bookmark); in code and data it's still the `pins`
                  array / `pinPost()`. Not the moderator's pinned announcement (`comment.pinned`).
                -->
                <button
                  #pinTt="ngbTooltip"
                  type="button"
                  class="btn action-pill action-pill--icon"
                  [class.action-pill--on]="comment.pins && comment.pins.includes(userService.user?.id)"
                  (keyup.enter)="pinPost(); pinTt.close()"
                  (click)="pinPost(); pinTt.close()"
                  [attr.aria-pressed]="comment.pins && comment.pins.includes(userService.user?.id)"
                  [attr.aria-label]="'com.save_post' | translate"
                  [ngbTooltip]="'com.save_post' | translate"
                >
                  <fa-icon icon="bookmark" aria-hidden="true"></fa-icon>
                  <span class="sr-only">{{ "com.save_post" | translate }}</span>
                </button>
              </li>
            }
            <!-- Community posts have no reply button: the reply prompt below the replies opens the composer. -->
            @if (!reviewing && !isCommunityPost) {
              <li class="list-inline-item">
                <button
                  #replyTt="ngbTooltip"
                  type="button"
                  class="btn action-pill"
                  [class.action-pill--icon]="!replies || !replies.length"
                  (keyup.enter)="toggleReplyUI(comment); replyTt.close()"
                  (click)="toggleReplyUI(comment); replyTt.close()"
                  aria-label="reply"
                  [attr.aria-expanded]="comment.replying"
                  [attr.aria-controls]="comment.key + '_reply_input_container'"
                  [ngbTooltip]="'com.reply' | translate"
                  placement="right"
                >
                  <fa-icon icon="reply" aria-hidden="true"></fa-icon>
                  @if (replies && replies.length) {
                    <span class="reply-count">{{ replies.length }}</span>
                  }
                  <span class="sr-only">reply</span>
                </button>
              </li>
            }
            @if (!reviewing) {
              <li class="list-inline-item">
                <button
                  #optsTt="ngbTooltip"
                  type="button"
                  class="btn action-pill action-pill--icon"
                  [ngbTooltip]="'sphere.options' | translate"
                  (keyup.enter)="msgOptions(comment); optsTt.close()"
                  (click)="msgOptions(comment); optsTt.close()"
                  aria-label="options"
                >
                  <fa-icon icon="ellipsis-h" aria-hidden="true"></fa-icon>
                  <span class="sr-only">options</span>
                </button>
              </li>
            }
            @if (comment.scheduled_date) {
              <li class="list-inline-item">
                <fa-icon icon="clock" class="c-official-blue"></fa-icon>
                Scheduled for {{ comment.scheduled_date.toDate() | date: "MMM Do" }} at {{ comment.scheduled_date.toDate() | date: "h:mma" }}
              </li>
            }
          }
        </ul>
        @if (betaStringId) {
          <div>
            <button class="brand-btn-reverse sm m-r-5" (click)="copyLink(comment)">
              {{ "com.copy_link" | translate }}&nbsp;
              <fa-icon icon="copy"></fa-icon>
            </button>
            @if (!isPostDetail && !isAnnouncement) {
              <button class="brand-btn-reverse sm" (click)="detailClick()">
                {{ "com.view_post" | translate }}&nbsp;
                <fa-icon icon="chevron-right"></fa-icon>
              </button>
            }
          </div>
        }
      </div>
    }
  </div>

  <!-- START | replies -->
  @if (replies && replies.length && !queued && !pinnedAndLocked) {
    <div class="d-block replies m-t-10 m-l-10" [class.w-full]="!isCommunityPost">
      @if (replies.length > 2 && !showingAllReplies) {
        <button type="button" class="btn btn-transparent p-1" (click)="showingAllReplies = !showingAllReplies" [ngbTooltip]="'Show ' + replies.length + ' Replies'" aria-label="show replies">
          <fa-icon icon="ellipsis-h" class="dot-link m-0" aria-hidden="true"></fa-icon>
          <span class="sr-only">show replies</span>
        </button>
      }
      @if (replies.length > 2) {
        <button class="msg-options-link text" (click)="showingAllReplies = !showingAllReplies">
          {{ showingAllReplies ? ("com.collapse_replies" | translate) : ("com.show_replies" | translate: { count: replies.length }) }}
        </button>
      }
      <ul class="list-group replies-list mb-0" role="group" aria-label="reply">
        <!-- Keyed by id, not object identity: the live watcher hands over fresh objects on every
             change, and identity tracking rebuilt every reply's DOM each time (jank, and a
             lost scroll position in long threads). -->
        @for (reply of replies; track reply.id ?? reply.key; let i = $index) {
          @if (showingAllReplies ? true : i == replies.length - 1 || i == replies.length - 2) {
            <li class="list-group-item border-0 bg-transparent p-0">
              <!-- First reply since your last visit to this thread — see `_placeNewRepliesMarker`. -->
              @if (reply.id === firstNewReplyId) {
                <div class="new-replies-divider" [id]="comment.key + '_new_replies'" role="separator">
                  <span>{{ "com.new_replies" | translate }}</span>
                </div>
              }
              <div class="reply-container" [id]="reply.id" [class.force-dark]="forceDark" [class.flagged]="user && user?.is_sphere_admin && reply.flags && !reply.cleared" aria-label="reply">
                @if (reply.flags && !reply.cleared) {
                  <div class="flag-warning bold">{{ reply.flags.length + " Flag" + (reply.flags.length > 1 ? "s" : "") + "!" }}</div>
                }
                <div class="msg">
                  <!-- The reply this one answers (`replyingToID`), resolved in `buildReplies()`. One level only: it shows the reply directly answered, never a chain. -->
                  @if (reply._replyTarget) {
                    @if (reply._replyTarget.missing) {
                      <div class="reply-reference reply-reference--missing">
                        <span class="reply-reference__elbow" aria-hidden="true"></span>
                        <span class="reply-reference__snippet">{{ "com.original_reply_deleted" | translate }}</span>
                      </div>
                    } @else {
                      <button
                        type="button"
                        class="reply-reference"
                        (click)="scrollToReply(reply._replyTarget.id)"
                        [attr.aria-label]="('com.replying_to_name' | translate: { name: reply._replyTarget.name }) + ': ' + reply._replyTarget.snippet"
                      >
                        <span class="reply-reference__elbow" aria-hidden="true"></span>
                        @if (reply._replyTarget.photo) {
                          <img [src]="reply._replyTarget.photo" class="reply-reference__avatar" alt="" aria-hidden="true" />
                        } @else {
                          <span class="reply-reference__avatar profile-photo-initials" [style.background-color]="reply._replyTarget.color" aria-hidden="true">{{ reply._replyTarget.initials }}</span>
                        }
                        <span class="reply-reference__name">{{ reply._replyTarget.name }}</span>
                        <span class="reply-reference__snippet">{{ reply._replyTarget.snippet }}</span>
                      </button>
                    }
                  }
                  <ul class="list-inline bold timestamp">
                    <li class="list-inline-item">
                      <a href="javascript:void(0)" (click)="viewProfile(reply.author.id)" class="profile-photo" [mypUserHoverCard]="reply.author.id" [hoverCardDisabled]="!isCommunityPost">
                        @if (reply.author.photo) {
                          <img
                            [src]="reply.author.photo + (reply.author.id == user?.id && userService.profilePhotoCacheBuster ? '?' + userService.profilePhotoCacheBuster : '')"
                            class="profile-photo"
                            [alt]="reply.author.name + ' profile photo'"
                          />
                        } @else {
                          <div class="profile-photo profile-photo-initials" [style.background-color]="reply.author._avatarColor" aria-hidden="true">
                            {{ reply.author._initials }}
                          </div>
                        }
                        <span class="sr-only">{{ reply.author.name }} profile</span>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0)" (click)="viewProfile(reply.author.id)" class="bold t-14 author-name" [class.force-dark]="forceDark">
                        {{ reply.author.name }}
                      </a>
                    </li>
                    @if (userService.badgeUsersMap?.community_wizards && userService.badgeUsersMap?.community_wizards[reply.author.id]) {
                      <li class="list-inline-item">
                        <div [ngbTooltip]="'com.community_moderator' | translate" [triggers]="isMobileScreen ? 'manual' : 'hover focus'" tabindex="0" [attr.role]="isMobileScreen ? 'button' : null">
                          <fa-icon icon="star" class="community-wizard-badge t-14" aria-hidden="true"></fa-icon>
                          <span class="sr-only">community moderator</span>
                        </div>
                      </li>
                    }
                    @if (userService.badgeUsersMap && userService.badgeUsersMap.employees && userService.badgeUsersMap.employees[reply.author.id]) {
                      <li class="list-inline-item">
                        <div [ngbTooltip]="'com.fender_employee' | translate" [triggers]="isMobileScreen ? 'manual' : 'hover focus'" tabindex="0" [attr.role]="isMobileScreen ? 'button' : null">
                          <img src="./assets/icons/fender-f.png" class="community-employee-badge" alt="fender employee" aria-hidden="true" />
                          <span class="sr-only">fender employee</span>
                        </div>
                      </li>
                    }
                    @if (userService.badgeUsersMap && userService.badgeUsersMap.experts && userService.badgeUsersMap.experts[reply.author.id]) {
                      <li class="list-inline-item">
                        <div [ngbTooltip]="'com.studio_one_expert' | translate" [triggers]="isMobileScreen ? 'manual' : 'hover focus'" tabindex="0" [attr.role]="isMobileScreen ? 'button' : null">
                          <fa-icon icon="graduation-cap" class="community-employee-badge t-14" aria-hidden="true"></fa-icon>
                          <span class="sr-only">studio one expert</span>
                        </div>
                      </li>
                    }
                    <li class="list-inline-item">
                      <span class="sr-only">posted on</span>
                      {{ reply.created.toDate() | date: "MMM Do [at] h:mma" : true }}
                    </li>
                  </ul>
                  @if (reply.message) {
                    @if (reply.htmlMessage || !reply.htmlSignature) {
                      <p class="text mb-0 w-full" [class.emoji-only-message]="reply.isEmojiOnly" [innerHTML]="reply.htmlMessage ? (reply.htmlMessage | safe: 'html') : reply.message"></p>
                    }
                    @if (reply.htmlSignature) {
                      <div class="post-signature w-full" [innerHTML]="reply.htmlSignature | safe: 'html'"></div>
                    }
                  }
                  @if (reply.files && reply.files.length && !queued) {
                    <div class="post-attachments" [class.multiple]="reply.files.length > 1">
                      @for (file of reply.files; track file) {
                        <div class="attachment" [class.is-image]="workspaceService.imageFiles[file.extension]">
                          @if (workspaceService.imageFiles[file.extension]) {
                            <div *inView>
                              <img [src]="communityService.buildFileUrl(file.user_id, file)" (click)="showImage(communityService.buildFileUrl(file.user_id, file))" class="image-border" alt="" />
                              <div class="p-x-5">
                                <span class="t-12 font-weight-bold">{{ file.filename }}</span>
                              </div>
                            </div>
                          }
                          @if (workspaceService.audioFiles[file.extension]) {
                            @if (communityService.displayAudioWaveforms) {
                              <div class="m-t-20">
                                @if (reply.shouldLoadWaveform) {
                                  <myp-waveform-comments (audioPlayed)="audioPlayed($event)" [showComments]="false" #waveformComments [isPostAttachment]="true" [file]="file"></myp-waveform-comments>
                                }
                                @if (!reply.shouldLoadWaveform) {
                                  <div style="height: 150px; background-color: rgba(0, 0, 0, 0.6)" class="d-flex align-items-center justify-content-center">
                                    <div class="text-center">
                                      <a class="btn btn-primary" (click)="reply.shouldLoadWaveform = true">{{ "com.load_waveform" | translate }}</a>
                                      <br />
                                      <span>{{ file.filesize | bytesToSize }}</span>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                            @if (!communityService.displayAudioWaveforms) {
                              <div
                                class="post-audio-play"
                                [class.pulse-blue]="communityService.playingAudioFile && communityService.playingAudioFile.id == file.id"
                                (click)="playAudio(file, reply.id, $event)"
                              >
                                <fa-icon
                                  tabindex="0"
                                  (keyup.enter)="playAudio(file, reply.id, $event)"
                                  [icon]="communityService.playingAudioFile && communityService.playingAudioFile.id == file.id ? 'stop-circle' : 'play-circle'"
                                  class="t-40"
                                ></fa-icon>
                                <div class="d-flex m-l-10 align-items-center">
                                  <div>
                                    <span class="t-20 bold d-block">{{ file.filename }}</span>
                                    <span class="text-muted t-16">{{ file.filesize | bytesToSize }}</span>
                                  </div>
                                </div>
                              </div>
                            }
                          }
                          @if (workspaceService.videoFiles[file.extension]) {
                            <div *inView>
                              <video width="100%" [src]="file.url" controls></video>
                            </div>
                          }
                          @if (!workspaceService.imageFiles[file.extension] && !workspaceService.audioFiles[file.extension] && !workspaceService.videoFiles[file.extension]) {
                            <div>
                              <div class="generic-file-attachment">
                                {{ file.filename }}
                                <fa-icon icon="download" tabindex="0" (keyup.enter)="downloadFile(file)" (click)="downloadFile(file)"></fa-icon>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (reply.articles && reply.articles.length && !queued) {
                    <ul class="post-attachments pl-0" role="group" aria-label="articles">
                      @for (item of reply.articles; track item) {
                        <li style="list-style-type: none">
                          <button type="button" class="comment-article-attachment bg-transparent" (click)="showArticle(item)">
                            <fa-icon icon="newspaper" class="icon" aria-hidden="true"></fa-icon>
                            <div class="d-flex flex-column text-left">
                              <fui-heading [text]="item.article.name" [level]="4" fontSize="f7" extraClasses="bold"></fui-heading>
                              <span class="t-12 text-muted" aria-label="article created at">{{ item.article.created_at_pretty }}</span>
                              <span class="link bold text-right">
                                {{ "com.read_article" | translate }}
                                <fa-icon icon="chevron-right" aria-hidden="true"></fa-icon>
                              </span>
                            </div>
                          </button>
                        </li>
                      }
                    </ul>
                  }
                  @if (reply.public_file_links && reply.public_file_links.length && !queued) {
                    <ul class="post-attachments pl-0" role="group" aria-label="links">
                      @for (item of reply.public_file_links; track item) {
                        <li style="list-style-type: none">
                          <button type="button" class="comment-article-attachment bg-transparent" (click)="goToPublicFile(item)">
                            <fa-icon [icon]="workspaceService.audioFiles[item.publicFile.extension] ? 'play-circle' : 'file'" class="icon" aria-hidden="true"></fa-icon>
                            <div class="d-flex flex-column text-left">
                              <fui-heading [text]="item.publicFile.filename" [level]="4" fontSize="f7" extraClasses="bold"></fui-heading>
                              <span class="t-12 text-muted" aria-label="file description">{{ item.publicFile.description }}</span>
                              <span class="link bold text-right">
                                {{ "com.view_and_comment" | translate }}
                                <fa-icon icon="chevron-right" aria-hidden="true"></fa-icon>
                              </span>
                            </div>
                          </button>
                        </li>
                      }
                    </ul>
                  }
                  @if (reply.learn_content && reply.learn_content.length && !queued) {
                    <div class="post-attachments m-y-20 grid-container pad-10">
                      @for (item of reply.learn_content; track item) {
                        @if (item.content.type == "video") {
                          <myp-video-grid-item [video]="item.content"></myp-video-grid-item>
                        }
                        @if (item.content.type == "course" || item.content.type == "lesson") {
                          <myp-learn-list-item [item]="item.content"></myp-learn-list-item>
                        }
                      }
                    </div>
                  }
                  @if (reply.embeds && reply.embeds.length && !queued) {
                    <div class="post-attachments m-y-20 grid-container pad-10">
                      @for (embed of reply.embeds; track embed) {
                        <div class="message-embed message-embed--{{ embed.type }} message-embed--{{ embed.subtype }}">
                          <iframe width="560" height="315" [src]="embed.src" frameborder="0" allowfullscreen></iframe>
                        </div>
                      }
                    </div>
                  }
                  <div class="timestamp">
                    <ul class="list-inline mb-0">
                      <!-- <li class="list-inline-item">
                      <span class="sr-only">posted on</span>
                      {{ reply.created.toDate() | date: "MMM Do [at] h:mma" }}
                    </li> -->
                      @if (!communityService.profile || !communityService.profile.status || communityService.profile.status == "active") {
                        @if (reply.edited) {
                          <li class="list-inline-item">
                            <span class="edited-message">{{ "com.edited" | translate }}</span>
                          </li>
                        }
                        <myp-reaction-control [comment]="reply" (reactionChange)="onReactionChange($event)" (viewProfile)="viewProfile($event)"></myp-reaction-control>
                        @if (!reviewing) {
                          <li class="list-inline-item">
                            <button
                              #replyReplyTt="ngbTooltip"
                              class="btn action-pill action-pill--icon"
                              [attr.aria-expanded]="comment.replying"
                              (keyup.enter)="toggleReplyUI(comment, reply, true); replyReplyTt.close()"
                              (click)="toggleReplyUI(comment, reply, true); replyReplyTt.close()"
                              aria-label="reply"
                              [attr.aria-controls]="comment.key + '_reply_input_container'"
                              [ngbTooltip]="'com.reply' | translate"
                              placement="right"
                            >
                              <fa-icon icon="reply" aria-hidden="true"></fa-icon>
                              <span class="sr-only">reply</span>
                            </button>
                          </li>
                        }
                        <li class="list-inline-item">
                          <button
                            #replyOptsTt="ngbTooltip"
                            class="btn action-pill action-pill--icon"
                            (keyup.enter)="msgOptions(reply); replyOptsTt.close()"
                            (click)="msgOptions(reply); replyOptsTt.close()"
                            aria-label="options"
                            [ngbTooltip]="'sphere.options' | translate"
                            placement="right"
                          >
                            <fa-icon icon="ellipsis-h" aria-hidden="true"></fa-icon>
                            <span class="sr-only">options</span>
                          </button>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              </div>
            </li>
          }
        }
      </ul>
    </div>
  }
  <!-- END | replies -->

  <!-- START | comment replying -->
  <!--
    Community posts always show a way to reply. Until it's used, that's this lightweight
    prompt dressed as the input rather than a real <myp-message-input>: the detailed feed
    renders every post through this component, and a live editor (Quill, for beta) per post
    would be a lot of editors. Opening goes through `toggleReplyUI` so the participation
    gate, sign-up prompt, draft restore and focus all behave as the old reply button did.
    Same conditions as the action row above, which is where the reply button used to live.
  -->
  @if (
    isCommunityPost && !comment.replying && !queued && !reviewing && !pinnedAndLocked && (!communityService.profile || !communityService.profile.status || communityService.profile.status == "active")
  ) {
    <button
      type="button"
      class="reply-prompt"
      [class.force-dark]="forceDark"
      (click)="toggleReplyUI(comment, undefined, true)"
      [attr.aria-controls]="comment.key + '_reply_input_container'"
      aria-expanded="false"
    >
      {{ "com.write_a_reply" | translate }}
    </button>
  }
  @if (comment.replying) {
    <!-- Ids are per post: the detailed feed can have several composers open at once. -->
    <div class="form-group m-b-0 w-full comment-replying" [id]="comment.key + '_comment_replying'">
      <label [id]="comment.key + '_reply_label'" class="control-label reply-label">{{ "com.reply" | translate }}</label>
      <!-- Set by a reply's own reply button; the send attaches it as `replyingToID`. -->
      @if (replyingToReply) {
        <div class="replying-to-banner">
          <span class="replying-to-banner__text">
            <span class="replying-to-banner__label">{{ "com.replying_to_name" | translate: { name: replyingToReply.author?.name } }}</span>
            @if (replyingToSnippet) {
              <span class="replying-to-banner__snippet">{{ replyingToSnippet }}</span>
            }
          </span>
          <button type="button" class="replying-to-banner__cancel" (click)="cancelReplyTarget()" [attr.aria-label]="'com.cancel_reply' | translate" [ngbTooltip]="'com.cancel_reply' | translate">
            <fa-icon icon="times" aria-hidden="true"></fa-icon>
          </button>
        </div>
      }
      <div
        class="d-block reply-input"
        (onFileDrop)="droppedFile($event)"
        ng2FileDrop
        [uploader]="uploader"
        (fileOver)="fileOverBase($event)"
        [class.hovering]="hasBaseDropZoneOver && isCommunityPost"
        [class.w-full]="!isCommunityPost"
        [id]="comment.key + '_reply_input_container'"
      >
        <myp-message-input
          #replyInput
          (returnPressed)="sendReply($event, comment)"
          type="span"
          [mentionSource]="isCommunityPost && !betaStringId && mentionsEnabled ? 'community_profiles' : false"
          [inputID]="comment.key + '_reply_input'"
          [useQuill]="!!betaStringId"
          [sendOnEnter]="sendOnEnter"
          [placeholder]="(sendOnEnter ? 'com.enter_to_send' : 'com.ctrl_enter') | translate"
          [backgroundColor]="appService.activeTheme == 'dark' || forceDark ? '#2e2e2e' : '#e9e9e9'"
          [includeSendButton]="true"
          [shouldDetectContent]="!betaStringId"
          (valueChanged)="replyContentChanged($event)"
          [ariaDescribedBy]="comment.key + '_reply_instructions'"
          [ariaLabelBy]="comment.key + '_reply_label'"
        ></myp-message-input>
      </div>
    </div>
    <!--
      The reply's options on one toolbar, as the post composer's: what to add (file, video,
      article), then how it goes out (save the post, signature), and how to send on the right.
    -->
    <div class="create-post-toolbar reply-toolbar">
      <div class="create-post-toolbar__tools">
        @if (!uploadingFile && isCommunityPost) {
          <button type="button" class="create-post-tool" (click)="attachFile()" [ngbTooltip]="'com.attach_file' | translate">
            <fa-icon icon="paperclip" aria-hidden="true"></fa-icon>
            <span class="sr-only">{{ "com.attach_file" | translate }}</span>
          </button>
          <button type="button" class="create-post-tool" (click)="showAttach('videos')" [ngbTooltip]="'com.attach_video' | translate">
            <fa-icon icon="video" aria-hidden="true"></fa-icon>
            <span class="sr-only">{{ "com.attach_video" | translate }}</span>
          </button>
          <button type="button" class="create-post-tool" (click)="showAttach('articles')" [ngbTooltip]="'com.attach_article' | translate">
            <fa-icon icon="newspaper" aria-hidden="true"></fa-icon>
            <span class="sr-only">{{ "com.attach_article" | translate }}</span>
          </button>
        }
        @if (!betaStringId && isCommunityPost) {
          @if (!uploadingFile) {
            <span class="create-post-toolbar__divider" aria-hidden="true"></span>
          }
          <!-- Saving the post you reply to, on by default; a toggle rather than a checkbox. -->
          <button
            type="button"
            class="create-post-tool create-post-tool--labeled"
            [class.is-on]="pinReplyingToPost"
            [attr.aria-pressed]="!!pinReplyingToPost"
            (click)="pinReplyingToPost = !pinReplyingToPost"
          >
            <fa-icon [icon]="pinReplyingToPost ? 'bookmark' : ['far', 'bookmark']" aria-hidden="true"></fa-icon>
            {{ "com.pin_this_post" | translate }}
          </button>
          @if (replySignature) {
            <button
              type="button"
              class="create-post-tool create-post-tool--labeled"
              [class.is-on]="replySignatureEnabled"
              [attr.aria-pressed]="replySignatureEnabled"
              (click)="replySignatureEnabled = !replySignatureEnabled"
            >
              <fa-icon icon="pencil-alt" aria-hidden="true"></fa-icon>
              @if (replySignatureEnabled) {
                Signature on
              } @else {
                Signature off
              }
            </button>
          }
        }
      </div>
      <span class="reply-toolbar__hint" [id]="comment.key + '_reply_instructions'">{{ (sendOnEnter ? "com.hit_enter_send" : "com.hit_ctrl_enter") | translate }}</span>
    </div>
  }
  <!-- END | comment replying -->

  @if (uploadingFiles && uploadingFiles.length && comment.replying) {
    <div>
      @for (file of uploadingFiles; track file) {
        <span class="text-muted t-14">{{ "general.uploading" | translate }}: {{ file.filename }} {{ file.progress }}%</span>
        <div class="post-progress-bar" [ngStyle]="{ width: (file.progress ? file.progress : 0) + '%' }" aria-hidden="true"></div>
      }
    </div>
  }

  @if (replyInput && replyInput.selectedArticlesInMessage && replyInput.selectedArticlesInMessage.length) {
    <div>
      @for (item of replyInput.selectedArticlesInMessage; track item) {
        <!-- The whole card opens the article by mouse; by keyboard its text is the button (the remove icon sits beside it, not inside). -->
        <div class="comment-article-attachment" (click)="showArticle(item)">
          <fa-icon icon="newspaper" class="icon" aria-hidden="true"></fa-icon>
          <div role="button" tabindex="0" (keydown.enter)="showArticle(item)" (keydown.space)="showArticle(item); $event.preventDefault()">
            <span class="bold">{{ item.article.name }}</span>
            <br />
            <span class="t-12 text-muted">{{ item.article.created_at_pretty }}</span>
          </div>
          <fa-icon
            icon="times-circle"
            class="close-btn"
            role="button"
            tabindex="0"
            aria-label="remove article"
            (click)="removeArticle(item, $event)"
            (keydown.enter)="removeArticle(item, $event)"
            (keydown.space)="removeArticle(item, $event); $event.preventDefault()"
          ></fa-icon>
        </div>
      }
    </div>
  }

  @if (replyInput && replyInput.selectedLearnContentInMessage && replyInput.selectedLearnContentInMessage.length) {
    <div class="m-y-20">
      @for (item of replyInput.selectedLearnContentInMessage; track item) {
        @if (item.content.type == "video") {
          <div class="grid-container wider pad-10">
            <myp-video-grid-item [showBorder]="true" [video]="item.content" [showRemoveFromPost]="true" (removeFromPostClicked)="removeLearnContent(item, $event)"></myp-video-grid-item>
          </div>
        }
        @if (item.content.type != "video") {
          <myp-learn-list-item
            [shouldShowButtons]="false"
            [showRemoveFromPost]="true"
            [item]="item.content"
            [preventNav]="true"
            (removeFromPostClicked)="removeLearnContent(item, $event)"
          ></myp-learn-list-item>
        }
      }
    </div>
  }

  @if (replyInput && replyInput.publicFileLinksInMessage && replyInput.publicFileLinksInMessage.length) {
    <div class="m-y-20">
      @for (item of replyInput.publicFileLinksInMessage; track item) {
        @for (item of replyInput.publicFileLinksInMessage; track item) {
          <div class="comment-article-attachment">
            <fa-icon [icon]="workspaceService.audioFiles[item.publicFile.extension] ? 'play-circle' : 'file'" class="icon"></fa-icon>
            <div>
              <span class="bold">{{ item.publicFile.filename }}</span>
              <br />
              <span class="t-12 text-muted">{{ item.publicFile.description }}</span>
            </div>
            <fa-icon
              icon="times-circle"
              class="close-btn"
              role="button"
              tabindex="0"
              aria-label="Remove public file"
              (click)="removePublicFile(item, $event)"
              (keydown.enter)="removePublicFile(item, $event)"
              (keydown.space)="removePublicFile(item, $event); $event.preventDefault()"
            ></fa-icon>
          </div>
        }
      }
    </div>
  }

  @if (replyInput && replyInput.messageEmbeds && replyInput.messageEmbeds.length) {
    <div class="d-flex flex-column m-y-20">
      @for (embed of replyInput.messageEmbeds; track embed) {
        <div class="message-embed message-embed--{{ embed.type }} message-embed--{{ embed.subtype }}">
          <fa-icon
            icon="times-circle"
            class="close-btn"
            role="button"
            tabindex="0"
            aria-label="Remove Embed"
            (click)="removeEmbed(embed, $event)"
            (keydown.enter)="removeEmbed(embed, $event)"
            (keydown.space)="removeEmbed(embed, $event); $event.preventDefault()"
          ></fa-icon>
          <iframe width="560" height="315" [src]="embed.embedSrc" frameborder="0" allowfullscreen></iframe>
        </div>
      }
    </div>
  }

  @if (uploadedAttachments && uploadedAttachments.length && comment.replying) {
    <div class="d-flex flex-wrap">
      @for (attachment of uploadedAttachments; track attachment) {
        <div class="attachment replying-attachment">
          @if (workspaceService.imageFiles[attachment.extension]) {
            <img [src]="attachment.url" class="image-border" style="width: 200px" alt="" />
          }
          @if (workspaceService.audioFiles[attachment.extension]) {
            <audio id="audio_player" controls="true">
              <source [src]="attachment.url" type="audio/wav" />
            </audio>
          }
          @if (!workspaceService.audioFiles[attachment.extension] && !workspaceService.imageFiles[attachment.extension]) {
            <span class="gothic t-18">
              <fa-icon icon="file" class="m-r-10"></fa-icon>
              <span>{{ attachment.filename }}</span>
            </span>
          }
          <div
            class="remove"
            role="button"
            tabindex="0"
            [attr.aria-label]="('general.remove' | translate) + ' ' + (attachment.filename || '')"
            (click)="removeAttachment(attachment)"
            (keydown.enter)="removeAttachment(attachment)"
            (keydown.space)="removeAttachment(attachment); $event.preventDefault()"
          >
            <fa-icon icon="times-circle" class="c-red" aria-hidden="true"></fa-icon>
          </div>
        </div>
      }
    </div>
  }

  <!-- START | Beta manager options -->
  @if (betaStringId && isBetaManager && !comment.pinned) {
    <div class="beta-manager-options">
      <hr />
      <div class="t-12 brandfont-black m-b-10">{{ "com.beta_manager_options" | translate }}</div>
      <div class="d-flex flex-wrap beta-status-container">
        <div class="beta-status m-r-5 m-b-20">
          <span class="t-12 bold text-muted d-inline-block m-r-10 status-text">{{ "com.type" | translate }}</span>
          <br />
          <select class="form-control custom-select-sm" (ngModelChange)="selectBetaPostType($event)" [(ngModel)]="comment.beta_type">
            <option value="none">{{ "com.beta_type.none" | translate }}</option>
            <option value="bug">{{ "com.beta_type.bug" | translate }}</option>
            <option value="feature_request">{{ "com.beta_type.feature_request" | translate }}</option>
            <option value="post">{{ "com.beta_type.post" | translate }}</option>
          </select>
        </div>
        <div class="beta-status m-l-5 m-b-20">
          <span class="t-12 bold text-muted d-inline-block m-r-10 status-text">{{ "com.status" | translate }}</span>
          <br />
          <select class="form-control custom-select-sm" (ngModelChange)="selectBetaPostStatus($event)" [(ngModel)]="comment.beta_status">
            <option value="none">{{ "com.beta_status.none" | translate }}</option>
            <option value="open">{{ "com.beta_status.open" | translate }}</option>
            <option value="cannot_reproduce">{{ "com.beta_status.cannot_reproduce" | translate }}</option>
            <option value="fixed">{{ "com.beta_status.fixed" | translate }}</option>
            <option value="investigating">{{ "com.beta_status.investigating" | translate }}</option>
            <option value="accepted">{{ "com.beta_status.accepted" | translate }}</option>
            <option value="rejected">{{ "com.beta_status.rejected" | translate }}</option>
            <option value="duplicate">{{ "com.beta_status.duplicate" | translate }}</option>
            <option value="by_design">{{ "com.beta_status.by_design" | translate }}</option>
          </select>
        </div>
      </div>
      <div>
        <div class="d-flex flex-wrap">
          <button class="brand-btn-reverse sm m-r-10" (click)="adminPinUnpinPost()" [attr.aria-label]="'com.pin_post' | translate">
            <fa-icon icon="thumbtack" class="m-r-5"></fa-icon>
            {{ "com.pin_post" | translate }}
          </button>
          @if (!comment.beta_review_details?.reviewed_by) {
            <button class="brand-btn-reverse sm m-r-10" (click)="toggleMarkingAsReviewed()">{{ "com.beta_actions.mark_reviewed" | translate }}</button>
          }
          @if (comment.beta_review_details?.reviewed_by) {
            <button class="brand-btn-reverse sm m-r-10" (click)="toggleMarkingAsReviewed()">{{ "com.beta_actions.edit_review" | translate }}</button>
            <button class="brand-btn-reverse sm m-r-10" (click)="removeReviewed()">{{ "com.beta_actions.remove_reviewed" | translate }}</button>
          }
          @if (!comment.beta_review_details?.jira_ticket_number) {
            <button class="brand-btn-reverse sm" (click)="createJiraTicket()">{{ "com.beta_actions.create_jira" | translate }}</button>
          }
        </div>
        @if (comment.beta_review_details?.reviewed_by) {
          <div class="m-t-10">
            <div>
              <fa-icon icon="check-circle" class="c-green m-r-10"></fa-icon>
              <span class="t-12 text-muted">
                @if (reviewedOnDate) {
                  {{ "com.reviewed_on" | translate }} {{ reviewedOnDate | date }} {{ "com.by" | translate }} {{ comment.beta_review_details.reviewed_by?.name }}
                } @else {
                  {{ "com.reviewed_by" | translate }} {{ comment.beta_review_details.reviewed_by?.name }}
                }
              </span>
            </div>
            @if (comment.beta_review_details.review_text) {
              <div class="t-12">{{ comment.beta_review_details.review_text }}</div>
            }
            @if (savedBetaReviewJiraBrowseUrl) {
              <div>
                <a [href]="savedBetaReviewJiraBrowseUrl" class="t-12" target="_blank">Jira Ticket {{ comment.beta_review_details.jira_ticket_number }}</a>
              </div>
            }
          </div>
        }
      </div>
      @if (markingAsReviewed) {
        <div>
          <textarea class="form-control m-y-10" [(ngModel)]="betaReviewDetails.review_text" [placeholder]="'com.add_relevant_notes' | translate"></textarea>
          <input class="form-control m-y-10 input-bg" [(ngModel)]="betaReviewDetails.jira_ticket_number" [placeholder]="'com.jira_ticket_number' | translate" />
          <button class="btn btn-primary btn-sm" (click)="markAsReviewed()">{{ "general.submit" | translate }}</button>
        </div>
      }
    </div>
  }
  @if (betaStringId && !isBetaManager && !comment.pinned) {
    <div>
      @if (comment.beta_type) {
        <div class="d-flex">
          <div style="width: 25px"><fa-icon [icon]="comment.beta_type == 'bug' ? 'bug' : 'question-circle'" [class.c-red]="comment.beta_type == 'bug'" class="m-r-10"></fa-icon></div>
          <span class="t-12 text-muted">{{ "com.type" | translate }} {{ comment.beta_type }}</span>
        </div>
      }
      @if (comment.beta_status) {
        <div class="d-flex">
          <div style="width: 25px"><fa-icon icon="info-circle" class="m-r-10"></fa-icon></div>
          <span class="t-12 text-muted">{{ "com.status" | translate }} {{ comment.beta_status }}</span>
        </div>
      }
      @if (comment.beta_review_details?.reviewed_by) {
        <div class="d-flex">
          <div style="width: 25px"><fa-icon icon="check-circle" class="c-green m-r-10"></fa-icon></div>
          <span class="t-12 text-muted">{{ "com.reviewed_on" | translate }} {{ reviewedOnDate | date }} {{ "com.by" | translate }} {{ comment.beta_review_details.reviewed_by?.name }}</span>
        </div>
      }
      @if (comment.beta_review_details?.jira_ticket_number) {
        <div class="d-flex">
          <div style="width: 25px"><fa-icon icon="ticket" class="c-official-blue m-r-10"></fa-icon></div>
          <span class="t-12 text-muted">Jira Ticket Number: {{ comment.beta_review_details.jira_ticket_number }}</span>
        </div>
      }
    </div>
  }
  <!-- END | Beta manager options -->
</div>
